import {
  afterRenderEffect,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef, input,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {register} from 'swiper/element/bundle';
import {IonButton, IonCol, IonIcon, IonRow} from '@ionic/angular/standalone';
import {RouterLink} from '@angular/router';
import Swiper from 'swiper';

register();

@Component({
  selector: 'app-content-swiper-slider',
  templateUrl: './content-swiper-slider.component.html',
  styleUrls: ['./content-swiper-slider.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    IonIcon,
    IonRow,
    IonCol,
    IonButton,
    RouterLink
  ]
})
export class ContentSwiperSliderComponent  implements OnInit {

  @ViewChild('swiper', { static: false}) swiperRef!: ElementRef;
  @ViewChild('swiper2', { static: false}) swiperRef2!: ElementRef;
  bgColor = input('');
  page = input('');
  items = input<any>([]);
  height = input('');
  sliderId = input('');
  title = input('');


  breakpoints = {
    320: {
      slidesPerView: 1.2
    },
    640: {
      slidesPerView: 1.6
    },
    1024: {
      slidesPerView: 2.8
    },
  }

  breakpointsAbout = {
    320: {
      slidesPerView: 1.2
    },
    640: {
      slidesPerView: 1.4
    },
    1024: {
      slidesPerView: 1.6
    },
  }
  constructor() {
    afterRenderEffect(() => {
      setTimeout(() => {
      // this.swiperRef?.nativeElement.swiper.initialize();
      // this.swiperRef2?.nativeElement.swiper.initialize();
        const swiperEl: any = document.getElementById(`${this.sliderId()}`);
        console.log(swiperEl, this.sliderId());
        swiperEl.initialize();
      }, 1500);
    });
  }

  ngOnInit() {
  }
  nextTestimonialSlide() {
    this.swiperRef?.nativeElement.swiper.slideNext();
    this.swiperRef2?.nativeElement.swiper.slideNext();
  }

  prevTestimonialSlide() {
    this.swiperRef?.nativeElement.swiper.slidePrev();
    this.swiperRef2?.nativeElement.swiper.slidePrev();
  }

}
